import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import CollectionsTableColumns from '../containers/CollectionsTableColumns';

const CollectionsTableHeader = ({
  category,
  children,
  collections,
  columns,
  hideColumns,
  readErrors,
  readStatus,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus === states.PENDING}
      error={firstErrorMessage(readErrors)}
      numberOfColumns={columns.length}
    >
      {children}
    </TableHeader>
    {!hideColumns && <CollectionsTableColumns category={category} items={collections} columns={columns} />}
  </Table.Header>
);

export default CollectionsTableHeader;
